// src/api/website-api/pagesApi.js
import axios from "axios";

const getStoreId = () => localStorage.getItem("storeId");

const getLanguageId = (lang = "en") => {
  return lang === "ar" ? 4 : 1;
};

const getPageHeaders = (lang = "en") => {
  const languageId = getLanguageId(lang);
  const storeId = getStoreId();

  const headers = {
    "Language-ID": languageId,
  };

  if (storeId) {
    headers["Store-ID"] = storeId;
  }

  return headers;
};

export const fetchRefundPolicy = async (lang = "en") => {
  const headers = getPageHeaders(lang);

  console.log("Refund Policy Headers:", headers, "Lang:", lang);

  const res = await axios.get(
    `${process.env.REACT_APP_API_POS_WITH_WEBSITE}/api/oc/information/6/`,
    { headers }
  );

  return res.data;
};